import {make} from 'vuex-pathify'
import json from '../../../static/experiences.json'

const state = {
    loaded: false,
    jobs: [],
    projects: [],
    entrepreneurships: [],
    internships: []
}

const mutations = {
    ...make.mutations(state)
}

const actions = {
    ...make.actions(state),
    loadExperiences ({commit}) {
        commit('SET_JOBS', json.jobs)
        commit('SET_PROJECTS', json.projects)
        commit('SET_ENTREPRENEURSHIPS', json.autoentrepreneur)
        commit('SET_INTERNSHIPS', json.internships)
        commit('SET_LOADED', true)
    }
}

const getters = {
    ...make.getters(state),
    isLoaded () {
        return state.loaded
    },
    getJobs () {
        return state.jobs
    },
    getProjects () {
        return state.projects
    },
    getEntrepreneurships () {
        return state.entrepreneurships
    },
    getInternships () {
        return state.internships
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/experiencesModule.js